import { buttonProps as t } from "../button/button.js";
const e = {
  size: t.size,
  type: t.type
}, p = Symbol("buttonGroupContextKey");
export {
  p as buttonGroupContextKey,
  e as buttonGroupProps
};
